import {DxLogoutStrategy} from "./dx-logout-strategy";
import {Injectable, Injector} from "@angular/core";
import {Observable} from "rxjs/index";
import {DxLogoutResult} from "../../../domain/authentication/dx-logout-result";
import {DxSessionService} from "../../dx-session.service";
import {DX_AUTH_CONFIG} from "../../../config/dx-auth-config";
import {DxAppError} from "../../../../dx-core/domain/error/dx-app-error";

@Injectable()
export class DxAsyncLogoutStrategy implements DxLogoutStrategy {

  constructor(private _injector: Injector,
              private _sessionService: DxSessionService) {
    const config = this._injector.get(DX_AUTH_CONFIG);
    if(config) {
      // TODO: Сделать с конфигом ченить :)
    } else {
      // TODO: Дефолные настроки
    }
  }

  // TODO: Реализовать механизм логаута в сессионном бэкенде
  // TODO: На успех затираем данные о сессии на клиенте
  // TODO: На ошибку выкидываем на аварийную страницу
  public logout(): Observable<DxLogoutResult> {
    const error: DxAppError = new DxAppError();
    error.message = 'Функциональность логаута в сессионном бэкенде не реализована!';
    throw error;
  }
}
